import React from "react";
import { Apple, CalendarClock } from "lucide-react";
import { APP_LINKS, APP_AVAILABLE_LABEL } from "../mock";

function GooglePlayIcon({ className = "" }) {
  return (
    <svg viewBox="0 0 512 512" className={className} aria-hidden="true">
      <path fill="#2fd645" d="M47 20 300 256 47 492c-8-5-13-14-13-25V45c0-11 5-20 13-25z" opacity="0" />
      <path fill="#00D4FF" d="M60 24c-6 4-10 11-10 20v424c0 9 4 16 10 20l236-232L60 24z" />
      <path fill="#2fd645" d="M60 24l236 232 66-65-243-142c-24-14-45-25-59-25z" />
      <path fill="#FFC800" d="M296 256l-236 232c14 0 35-11 59-25l243-142-66-65z" />
      <path fill="#FF3D57" d="M362 191l-66 65 66 65 79-46c22-13 22-25 0-38l-79-46z" />
    </svg>
  );
}

export default function AppBadges({ className = "", size = "default", showNote = true }) {
  const pad = size === "lg" ? "px-5 py-3.5" : "px-4 py-3";
  return (
    <div className={className}>
      <div className="flex flex-col sm:flex-row gap-3">
        <a
          href={APP_LINKS.ios}
          target="_blank"
          rel="noreferrer"
          className={`group flex items-center gap-3 rounded-xl border border-white/15 bg-black ${pad} transition-all duration-300 hover:border-[#2fd645] hover:-translate-y-0.5`}
        >
          <Apple className="h-7 w-7 text-white" fill="currentColor" />
          <div className="text-left leading-none">
            <div className="text-[10px] uppercase tracking-wider text-white/60">Download on the</div>
            <div className="text-lg font-semibold text-white -mt-0.5">App Store</div>
          </div>
        </a>
        <a
          href={APP_LINKS.android}
          target="_blank"
          rel="noreferrer"
          className={`group flex items-center gap-3 rounded-xl border border-white/15 bg-black ${pad} transition-all duration-300 hover:border-[#2fd645] hover:-translate-y-0.5`}
        >
          <GooglePlayIcon className="h-6 w-6" />
          <div className="text-left leading-none">
            <div className="text-[10px] uppercase tracking-wider text-white/60">Get it on</div>
            <div className="text-lg font-semibold text-white -mt-0.5">Google Play</div>
          </div>
        </a>
      </div>
      {showNote && (
        <div className="mt-3 inline-flex items-center gap-2 text-sm text-[#2fd645]">
          <CalendarClock className="h-4 w-4" />
          <span>Available to download from {APP_AVAILABLE_LABEL}</span>
        </div>
      )}
    </div>
  );
}
